import { ErrorResponse } from '~shared/models';
import { Category } from '~app/modules/generic/models';

export interface CategoriesState {
  payload: Category[];
  loading: boolean;
  isLoaded: boolean;
  error: ErrorResponse;
}

export const categoriesInitialState: CategoriesState = {
  payload: [],
  loading: false,
  isLoaded: false,
  error: null,
};
